import type { EntityList } from '../state/EntityList.type'
import type { EntityGridXY } from './EntityGridXY.type'

/**
 * @deprecated use getGrid
 */
export default function getEntityGridXYStack(
  grid: EntityGridXY,
  x: number,
  y: number): EntityList {
  return grid[x]?.[y] || []
}
